





























































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { storeRefFaskes } from "@/store/modules/bridgingVclaim/RefFaskes";
import { storeRefPoli } from "@/store/modules/bridgingVclaim/RefPoli";
import { storeRefDokter } from "@/store/modules/bridgingVclaim/RefDokter";
import { storeRefDiagnosa } from "@/store/modules/bridgingVclaim/RefDiagnosa";
import { storeSEP } from "@/store/modules/bridgingVclaim/SEP";
import SEP from "@/services/bridgingVclaim/SEP";

import moment from "moment";
import PrepSep from "@/services/bridgingVclaim/PrepSep";
import ReferensiUnit from "@/store/modules/new/ReferensiUnit";
import DokterSimrs from "@/services/DokterSimrs";
import { isJsonStr } from "@/utility/CommonHelper";
import SrkSvc from "@/services/bridgingVclaim/SRK";
import Rujukan from "@/services/bridgingVclaim/Rujukan";
import Peserta from "@/services/bridgingVclaim/Peserta";
import { appModule } from "@/store/modules/app";
import type { IfcPrepSepData } from "@/types/bridging_bpjs";

@Component({
  components: {}
})
export default class InputSEPSimple extends Vue {
  showDpjpSKDP = true;
  asalRujukan = "";
  ppkRujukan = "";
  diagnosaAwal = "";
  poliTujuan = "";
  dpjpSep = "";
  noSrk = "";
  dpjpSrk = "";
  tglSrk = null;
  tglRujukan = "";
  noKartu = "";
  noRujukan = "";
  noSEP = "";
  telp = "";
  cm = "";
  unitId = "";
  drId = "";
  tgl = moment().format("YYYY-MM-DD");
  jnsKunjungan = "";
  prepId = null;
  register = "";

  tglPulangModalShowed = false;
  enabledPenunjangItem = [];

  dataFromIframe = "data from iframe";
  stsPrep = null;
  isSendAntrol = true;
  stsAntrol = false;
  isModeSendAntrol = false;

  itemsProv = [];

  itemsKab = [];

  itemsKec = [];

  listDokter = [];

  tglShow = false;

  msgPrepSep = "";
  msgStsAntrol = "";

  saving = false;
  printing = false;
  sendingDigiclaim = false;
  loadingSrk = false;
  loadingRujukan = false;
  removing = false;
  preping = false;
  sendingAntrol = false;

  respPostSep = null;
  parentNoSep = "";
  parentUsername = "";
  sepOnly = false;
  isShowModalPeserta = false;
  dataPeserta = null;
  loadingPeserta = false;
  dataPrep: IfcPrepSepData | null = null;
  showRujukanFields = true;

  get peserta() {
    return this.dataPeserta?.peserta;
  }

  get canShowProsesBtn() {
    return !this.noSEP && this.stsPrep && this.register;
  }

  get showSrkFields() {
    return this.noSrk.length > 3 || ['3', '5'].includes(this.jnsKunjungan)
  }

  mounted() {
    storeRefFaskes.act_ref_faskes("");
    storeRefPoli.getListPoli();
    storeRefDokter.act_ref_dokter("");
    storeRefDiagnosa.act_ref_diagnosa("");
    this.getDokterSimrs();

    window.addEventListener("message", this.listenIframeParentEvent);
  }

  listenIframeParentEvent(ev) {
    if (["http://10.10.187.6", "http://10.10.187.37"].includes(ev.origin))
      return false;

    const data = isJsonStr(ev.data) ? JSON.parse(ev.data) : null;

    console.log("CHILD receive from parent", data);
    console.log("source = ", ev.source, "origin = ", ev.origin);

    this.dataFromIframe = data;
  }

  sendToIframeParent(data) {
    const ifData = JSON.stringify(data);

    // console.log("send to iframe parent", ifData);

    parent.postMessage(ifData, "*");
  }

  @Watch("dataFromIframe")
  changeDataFromIframe(
    val: null | {
      event: string;
      data?: null | {
        rm: string;
        tgl: string;
        unitId: string;
        drId: string;
        username?: string;
        noSep?: string;
        register?: string;
        sendAntrolMode: boolean;
        noKartu?: string;
      };
    }
  ) {
    console.log("watch dataFromIframe", val);

    if (val) {
      if (val.event === "GET_PREP") {
        if (val.data) {
          this.cm = val.data.rm;
          this.unitId = val.data.unitId;
          this.drId = val.data.drId;
          this.parentNoSep = val.data?.noSep;
          this.parentUsername = val.data?.username;
          this.register = val.data?.register;
          this.isModeSendAntrol = val.data?.sendAntrolMode;
          this.noKartu = val.data?.noKartu;

          this.prepAntrol();
        } else {
          this.clear();
        }
      }

      if (val.event === "SEND_DIGICLAIM") {
        this.sendSepToDigiclaim();
      }

      if (val.event === "CLEAR") {
        this.clear();
      }

      if (val.event === "POST_SEP") {
        this.register = val.data.register;
        console.log("register post sep", this.register, val.data.register);

        this.$nextTick(() => {
          this.postPAntrol();
        });
      }

      this.dataFromIframe = null;
    }
  }

  sendSepToDigiclaim() {
    if (!this.sendingDigiclaim) {
      this.sendingDigiclaim = true;

      SEP.sendToDigiclaim(this.noSEP)
        .then(resp => {
          if (resp.status == 1) {
            alert(`SEP: ${this.noSEP} sent to digiclaim!`);
          } else {
            alert(resp.message);
          }
        })
        .finally(() => {
          this.sendingDigiclaim = false;
        });
    }
  }

  async getDokterSimrs() {
    this.listDokter = await DokterSimrs.getAll();
  }

  @Watch("cm")
  changeCm(val: string) {
    if (!val || (val && val.length < 6)) {
      this.clear();
    }

    if (val && val.length >= 6) {
      this.$nextTick(() => {
        this.cm = val.replace(/\D/g,'').substring(0, 6);
      })
    }
  }

  @Watch("noRujukan")
  async changeNoRujukan(newVal: string, oldVal: string) {
    if (newVal && newVal.length === 19 && newVal !== oldVal) {
      if (this.jnsKunjungan == "5") {
        this.ppkRujukan = this.dataPrep.rujukan?.asalFaskes;
        this.diagnosaAwal = this.dataPrep.rujukan?.diagnosa;
      } else {
        await this.getDataRujukan();
      }
    } else {
      this.clearRujukan();
    }
  }

  clearRujukan() {
    this.ppkRujukan = null;
    this.diagnosaAwal = null;
  }

  @Watch("noSrk")
  async changeNoSrk(newVal: string, oldVal: string) {
    if (newVal && newVal.length === 19 && newVal !== oldVal) {
      await this.getDataSrk();
    } else {
      this.clearSrk();
    }
  }

  @Watch('showSrkFields')
  changeShowSrkField(val) {
    if (!val) {
      this.tglSrk = '';
      this.noSrk = ''
      this.dpjpSrk = ''
    }
  }

  clearSrk() {
    this.dpjpSrk = null;
    this.tglSrk = this.tgl;
  }

  // changeTelp() {
  //   this.prepAntrol();
  // }

  // @Watch("dpjpSrk")
  // changeDpjpSrk(newVal, oldVal) {
  //   if (newVal) {
  //     this.prepAntrol();
  //   }
  // }

  // @Watch("tglSrk")
  // changeTglSrk(newVal, oldVal) {
  //   if (newVal) {
  //     this.prepAntrol();
  //   }
  // }

  @Watch("jnsKunjungan")
  changejnsKunjungan(newVal, oldVal) {
    if (!['3', '5'].includes(newVal)) {
      this.noSrk = '';
      this.tglSrk = '';
      this.dpjpSrk = '';
    }

    if (newVal == 'RD') {
      this.noRujukan = null;
      this.ppkRujukan = null;
      this.poliTujuan = 'IGD';
      this.showRujukanFields = false;
    } else {
      this.showRujukanFields = true;
    }
  }

  get username() {
    const user =
      this.parentUsername && this.parentUsername.length > 0
        ? this.parentUsername
        : "user";
    return `${user}@simrsps`;
  }

  get sep() {
    return storeSEP.sep;
  }

  get listPPKRujukan() {
    return storeRefFaskes.refFaskes;
  }
  get listPoliTujuan() {
    return storeRefPoli.refPoli;
  }
  get listDpjpSep() {
    return storeRefDokter.refDokter;
  }
  get listDiagnosaAwal() {
    return storeRefDiagnosa.refDiagnosa;
  }

  get listUnit() {
    return ReferensiUnit.unit;
  }

  get listJenisKunjungan() {
    return [
      { id: "1", name: "Rujukan FKTP" },
      { id: "2", name: "Rujukan Internal" },
      { id: "3", name: "Kontrol" },
      { id: "4", name: "Rujukan Antar RS" },
      { id: "5", name: "Kontrol Post Ranap" }
      // { id: "RD", name: "Kunjungan IGD" }
    ];
  }

  @Watch("srk")
  ceksrk(val) {
    if (val) {
      this.showDpjpSKDP = false;
    } else {
      this.showDpjpSKDP = true;
      this.dpjpSrk = "";
    }
  }

  // jangan dihapus dulu untuk update sep dapat dari prep
  @Watch("noSEP")
  changeNoSep(val) {
    if (val) {
      this.sendToIframeParent({
        event: "CHG_NO_SEP",
        data: {
          noSep: val
        }
      });
    }
  }

  sendAntrol() {
    this.sendToIframeParent({
      event: "SEND_ANTROL",
      data: null
    });
  }

  clear() {
    this.cm = "";
    this.telp = "";
    this.asalRujukan = "";
    this.ppkRujukan = "";
    this.diagnosaAwal = "";
    this.poliTujuan = "";
    this.dpjpSep = "";
    this.noSrk = "";
    this.dpjpSrk = "";
    this.saving = false;
    this.noKartu = "";
    this.noRujukan = "";
    this.noSEP = "";
    this.jnsKunjungan = "";
    this.isSendAntrol = true;
    this.prepId = null;
    this.register = "";
    this.sepOnly = false;
    this.stsPrep = false;
    this.isModeSendAntrol = false;
    this.stsAntrol = false;

    this.msgPrepSep = "";
    this.msgStsAntrol = "";
  }

  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD MMMM YYYY") : "";
  }

  get paramsPrepAntrol() {
    const dokterSepId = this.listDokter.find(
      item => item.bpjs_id == this.dpjpSep
    )?.kode;

    return {
      rm: this.cm,
      tgl: this.tgl,
      unit_id: this.unitId,
      dokter_id: this.dpjpSep ? dokterSepId : this.drId,
      telp: this.telp,
      noKartu: this.noKartu,
      poliTujuan: this.poliTujuan,
      diagnosa: this.diagnosaAwal,
      noRujukan: this.noRujukan,
      noSrk: this.noSrk,
      dpjpSrk: this.listDokter.find(item => item.bpjs_id == this.dpjpSrk)?.kode,
      tglSrk: this.tglSrk,
      jnsKunjungan: this.jnsKunjungan,
      user: this.username
    };
  }

  validateNoTelp() {
    if (this.telp.length > 13) {
      return false;
    }

    if (this.findUniqueString(this.telp) == "0") {
      return false;
    }

    return true;
  }

  validateRm() {
    if (!this.cm || this.cm.length < 6) {
      return false;
    }

    return true;
  }

  async prepAntrol() {
    if (!this.validateNoTelp()) {
      alert(
        `No.Telp ${this.telp} tidak valid. Tidak boleh kosong, lebih dari 13 karakter, atau 000000000000!`
      );
      return false;
    }

    if (!this.validateRm()) {
      alert(
        `No.RM ${this.cm} tidak valid. Tidak boleh kosong dan harus 6 karakter!`
      );
      return false;
    }

    if (!this.preping) {
      this.preping = true;

      await PrepSep.prepAntrol(this.paramsPrepAntrol)
        .then(resp => {
          console.log("response prep antrol", resp);
          this.stsPrep = resp.status == 1 ? true : false;

          if (resp.status != 1 && !this.parentNoSep) {
            let msg = resp.message;

            if (resp.code == 'ERR_INACTIVE_PST') {
              msg = `Response BPJS: ${msg}`
            }

            alert(msg);

            this.msgPrepSep = msg;
          } else {
            this.msgPrepSep = null;
          }

          const data = resp.data;
          this.dataPrep = resp.data;

          if (data.sep?.no) {
            this.noSEP = data.sep.no;
            this.changeNoSep(data.sep.no);
          } else {
            this.noSEP = null;
          }

          this.prepId = resp.prep_id;
          this.cm = this.trimNoRm(data.rm);
          this.noKartu = this.noKartu ? this.noKartu : data.noka;
          this.telp = this.telp ? this.telp : data.telp;

          if (data.rujukan) {
            this.noRujukan = data.rujukan.noKunjungan;
            this.ppkRujukan = data.rujukan.provPerujuk;
            this.diagnosaAwal = data.rujukan.diagnosa;
            this.dpjpSep = data.dokter?.bpjsId.toString();

            if (this.jnsKunjungan != '2' && data.jenis_kunjungan != '2') {
              this.poliTujuan = data.rujukan.poliRujukan;
            }

            this.sendToIframeParent({
              event: "UPDT_FIELD",
              data: {
                faskesId: data.rujukan.provPerujuk,
                prepId: resp.prep_id,
                prepStat: resp.status
              }
            });
          }

          if (data.srk) {
            this.noSrk = data.srk.noSuratKontrol;
            this.dpjpSrk = data.srk.kodeDokter;
            this.tglSrk = data.srk.tglRencanaKontrol;
          }

          if (data.jenis_kunjungan) {
            this.jnsKunjungan = data.jenis_kunjungan.toString();
          }

          this.stsAntrol = data?.antrol.status == 1;
          this.msgStsAntrol =
            data?.antrol.status == 1 ? "" : data.antrol.message;

          if (this.isModeSendAntrol && !this.stsAntrol) {
            alert(`Pesan Pengiriman Antrol: ${data.antrol.message}`);
          }

          this.sendToIframeParent({
            event: "UPDT_STSPREP",
            data: resp
          });
        })
        .finally(() => {
          this.preping = false;
        });
    }
  }

  get paramsPostPAntrol() {
    return {
      prep_id: this.prepId,
      register: this.register,
      sendAntrol: this.sepOnly ? false : true,
      sepOnly: this.sepOnly
    };
  }

  async postPAntrol() {
    if (!this.telp) {
      alert("No.Telp tidak boleh kosong!");
      return false;
    }

    if (!this.prepId) {
      alert(
        "Data SEP belum dapat diproses. Klik tombol Reload SEP terlebih dahulu hingga indikator berwarna hijau!"
      );
      return false;
    }

    if (!this.register && !this.sepOnly) {
      alert("Tidak bisa membuat SEP bila pasien belum didaftarkan!");
      return false;
    }

    if (!this.saving) {
      this.saving = true;
      await PrepSep.postPAntrol(this.paramsPostPAntrol)
        .then(
          (resp: {
            status: number;
            data?: {
              sep: string;
            };
            message?: string;
          }) => {
            if (resp.status == 1) {
              this.noSEP = resp.data.sep;

              this.changeNoSep(this.noSEP);
            } else {
              alert(resp.message ?? "Undefined ERR at POST pendaftaran-sep");
            }

            console.log("post p antrol", resp);

            this.respPostSep = resp;
          }
        )
        .finally(() => {
          this.saving = false;
        });
    }
  }

  getDataSrk() {
    if (!this.loadingSrk) {
      this.loadingSrk = true;

      SrkSvc.showOnline(this.noSrk)
        .then(resp => {
          if (resp.status == 1) {
            if (resp.data.sep.peserta.noKartu === this.noKartu) {
              this.dpjpSrk = resp.data.kodeDokter;
              this.tglSrk = resp.data.tglRencanaKontrol;

            } else {
              this.dpjpSrk = null;
              this.tglSrk = null;
              alert(
                "SRK No: " +
                  resp.data.noSuratKontrol +
                  " adalah milik peserta a/n " +
                  resp.data.sep.peserta.nama +
                  " noka: " +
                  resp.data.sep.peserta.noKartu +
                  ". Tidak sesuai untuk pasien ini."
              );
            }
          } else {
            this.dpjpSrk = null;
            this.tglSrk = null;

            alert(resp.message);
          }
        })
        .finally(() => {
          this.loadingSrk = false;
        });
    }
  }

  getDataRujukan() {
    if (!this.loadingRujukan) {
      this.loadingRujukan = true;

      Rujukan.getByNoRujukanOnline(this.noRujukan)
        .then(resp => {
          if (resp.status == 1) {
            const rjk = resp.data.response.rujukan;

            if (rjk.peserta.noKartu === this.noKartu) {
              this.ppkRujukan = rjk.provPerujuk.kode;
              this.diagnosaAwal = rjk.diagnosa.kode;

              if (this.jnsKunjungan != '2') {
                this.poliTujuan = rjk.poliRujukan.kode;
              }

            } else {
              this.ppkRujukan = null;
              this.diagnosaAwal = null;
              this.poliTujuan = null;

              alert(
                "Rujukan No: " +
                  rjk.noKunjungan +
                  " adalah milik peserta a/n " +
                  rjk.peserta.nama +
                  " noka: " +
                  rjk.peserta.noKartu +
                  ". Tidak sesuai untuk pasien ini."
              );
            }
          } else {
            this.ppkRujukan = null;
            this.diagnosaAwal = null;
            this.poliTujuan = null;

            alert(resp.message);
          }
        })
        .finally(() => {
          this.loadingRujukan = false;
        });
    }
  }

  confirmDialog(msg, yesCallback, noCallback = null) {
    const conf = confirm(msg);

    if (conf) {
      yesCallback();
    } else {
      noCallback ? noCallback() : null;
    }
  }

  removeSep() {
    this.confirmDialog("Anda yakin menghapus SEP ini?", () => {
      if (!this.removing) {
        this.removing = true;

        SEP.remove(this.noSEP, "user@simrsps")
          .then(resp => {
            if (resp.data.status) {
              alert(`SEP No: ${this.noSEP} berhasil dihapus!`);
              this.noSEP = "";
              this.msgPrepSep = "";

              this.sendToIframeParent({
                event: "CHG_NO_SEP",
                data: {
                  noSep: ""
                }
              });
            } else {
              alert(resp.data.message);
            }
          })
          .finally(() => {
            this.removing = false;
          });
      }
    });
  }

  previewSep() {
    SEP.print(this.noSEP);
  }

  getPesertaInfo() {
    if (this.noKartu && this.noKartu.length > 12) {
      this.loadingPeserta = true;

      Peserta.getByNoka(this.noKartu, this.tgl)
        .then(resp => {
          console.log("response get peserta", resp);

          if (resp.status == 1) {
            this.dataPeserta = resp.data;

            this.isShowModalPeserta = true;
          } else {
            alert(resp.message);
          }
        })
        .finally(() => {
          this.loadingPeserta = false;
        });
    } else {
      alert(
        "Tidak bisa mencari data peserta: No. Kartu BPJS minimal 13 karakter!"
      );
    }
  }

  @Watch("isShowModalPeserta")
  changeIsShowModalPeserta(val) {
    if (!val) {
      this.dataPeserta = null;
    }
  }

  @Watch("unitId")
  changeUnitId(val) {
    const match = this.listUnit.find(item => item.id == val);

    this.poliTujuan = match?.bpjsId;
  }

  @Watch("drId")
  changeDrId(val) {
    const match = this.listDokter.find(item => item.kode == val);

    this.dpjpSep = match?.bpjs_id;
  }

  cetak() {
    if (!this.printing) {
      this.printing = true;
      SEP.print(this.noSEP);
      this.printing = false;
    }
  }

  showTglPulangModal() {
    this.tglPulangModalShowed = true;
  }

  closeTglPulangModal() {
    this.tglPulangModalShowed = false;
  }

  findUniqueString(str) {
    return [...str].reduce((acc, curr) => {
      return acc.includes(curr) ? acc : acc + curr;
    }, "");
  }

  trimNoRm(str) {
    return str.replace(/^98+/, "").replace(/\D/g, "").substring(0,6);
  }
}
